import { useRouter } from 'next/router'

export const useSpotSwapRouter = () => {
  const { route, asPath } = useRouter()
  return asPath === '/instant' || /^\/exchange/g.test(route)
}
